export default __webpack_public_path__ + "static/media/cookie.d9acadc4.svg";